export default "__VITE_ASSET__ffa12e8c__"